export default [
  {
    path:"/iframe",
    component: resolve => require(['@/components/iframe/Index'], resolve),
    children: [
      {
        path: 'dataAnalysis/teamData',
        component: resolve => require(['@/components/iframe/DataAnalysis/TeamData'], resolve),
      },
      {
        path: 'dataAnalysis/playerData',
        component: resolve => require(['@/components/iframe/DataAnalysis/PlayerData'], resolve),
      },
      {
        path: 'matchSchedule/regularSeason',
        component: resolve =>
          require(['@/components/iframe/MatchSchedule/RegularSeason'], resolve)
      },
      {
        path: 'matchSchedule/playOffs',
        component: resolve =>
          require(['@/components/iframe/MatchSchedule/PlayOffs'], resolve)
      },
      {
        path: 'matchData/teamData',
        component: resolve =>
          require(['@/components/iframe/MatchData/TeamData'], resolve)
      },
      {
        path: 'matchData/mapData',
        component: resolve =>
          require(['@/components/iframe/MatchData/MapData'], resolve)
      },
    ],
  },
  {
    path: '/judge/login',
    component: resolve => require(['@/components/judge/JudgeLogin'], resolve),
    meta: {
      site: 'judge',
      judgeLogin: false,
      title: '裁判登录'
    }
  },
  {
    path: '/judge',
    component: resolve => require(['@/components/judge/Index'], resolve),
    meta: {
      site: 'judge',
      judgeLogin: false,
    },
    children: [{
      path: 'live_manager',
      component: resolve => require(['@/components/judge/LiveManager'], resolve),
      meta: {
        site: 'judge',
        judgeLogin: true,
        title: '直播控制'
      }
    }, {
      path: 'game_manager',
      component: resolve => require(['@/components/judge/GameManager'], resolve),
      meta: {
        site: 'judge',
        judgeLogin: true,
        title: '比赛管理'
      }
    }, ],
  },
  {
    path: '/tool/create_player_banner',
    component: resolve => require(['@/components/tool/CreatePlayerBanner'], resolve)
  },
  {
    path: '/tool/upload_excel',
    component: resolve => require(['@/components/tool/UploadExcel'], resolve)
  },
  {
    path: '/tool',
    component: resolve => require(['@/components/tool/DataToolsNew'], resolve),
    children: [
      {
        path: 'poster/fiveKills',
        component: resolve => require(['@/components/tool/poster/fiveKills/FiveKills'], resolve),
      },
      {
        path: 'poster/game',
        component: resolve => require(['@/components/tool/poster/game/Game'], resolve),
      }
    ],
  },
  {
    path: '/tool/realtime_odds',
    component: resolve => require(['@/components/tool/RealtimeOdds'], resolve)
    // component: resolve => require(['@/components/tool/CreatePlayerBanner'], resolve)
  },
  {
    path: '/playerRadar',
    component: resolve =>
      require(['@/pages/PlayerRadarPC'], resolve)
  },
  {
    path: '/live',
    meta: {
      site: 'judge',
      judgeLogin: false,
    },
    component: resolve => require(['@/components/live/Index'], resolve),
    children: [
      {
        path: 'live',
        meta: {
          site: 'judge',
          judgeLogin: true,
        },
        component: resolve => require(['@/components/live/live/Live'], resolve),
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/router/routrPC.js